import { commonAxios } from "../utils/AxiosSettings";
export async function getReportingData(queryUrl) {
    let url = queryUrl?.href;
    if (url) {
        const res = await commonAxios.get(url);
        return res;
    }
}
